/**
 * Transformer that is triggered after a new item has been loaded.
 * It sets in input state `is_item_loading` to `false` to hide a spinner
 * because while a new item is being loaded, the spinner is displayed.
 */
export default (kasko) => {
  kasko.addEventListener('item-loaded', () => {
    if (kasko.getState('input.is_item_loading')) {
      kasko.dispatchEvent('set-state-input', {
        is_item_loading: false,
      });
    }
  });
};
